import React, { Component } from 'react'

class KeyListener extends Component {
  constructor (props) {
    super(props)
    this.handleKeyUp = this.handleKeyUp.bind(this)
  }

  componentWillMount () {
    window.addEventListener('keyup', this.handleKeyUp)
  }

  componentWillUnmount () {
    window.removeEventListener('keyup', this.handleKeyUp)
  }

  handleKeyUp (e) {
    switch (e.keyCode) {
      case 13: return this.props.onEnter()
      case 49: return this.props.onNumber(1)
      case 50: return this.props.onNumber(2)
      case 51: return this.props.onNumber(3)
      case 52: return this.props.onNumber(4)
      case 53: return this.props.onNumber(5)
      case 54: return this.props.onNumber(6)
      case 55: return this.props.onNumber(7)
      case 56: return this.props.onNumber(8)
      case 57: return this.props.onNumber(9)
      case 48: return this.props.onNumber(10)
      default: return
    }
  }

  render () {
    return null
  }
}

KeyListener.displayName = 'KeyListener'

KeyListener.propTypes = {
  onEnter: React.PropTypes.func.isRequired,
  onNumber: React.PropTypes.func.isRequired,
}

KeyListener.defaultProps = {
  onEnter: () => {},
  onNumber: () => {}
}

export default KeyListener



// WEBPACK FOOTER //
// ./src/lib/KeyListener.js